<template >

<div >
    <MainComponent v-motion-fade-in />
</div >

</template>

<script lang="ts">
import { defineComponent } from 'vue';
import MainComponent from '../components/MainComponent.vue';

export default defineComponent({
    name: 'MainView-Componenten',
    components: {
        MainComponent,
    },
    data() {
        return {
        };
    },
    methods: {
    },
});
</script>
